import {
  Box,
  Card,
  CardBody,
  Center,
  Spacer,
  Stack,
  Text,
  Wrap,
  WrapItem,
} from "@chakra-ui/react";
import { FaMousePointer } from "react-icons/fa";
import { MdQuestionAnswer } from "react-icons/md";
import { TbMessageQuestion } from "react-icons/tb";
import { useContaxt } from "../../context/Context";
import { ActionButton } from "../ActionButton";
import { HeadLine } from "../HeadLine";

export function CallAction() {
  const { color, marginTop, variant } = useContaxt();

  const infos = [
    {
      icon: <FaMousePointer size={52} />,
      text: "Klicke auf den Button",
    },
    {
      icon: <TbMessageQuestion size={52} />,
      text: "Beantworte die Fragen",
    },
    {
      icon: <MdQuestionAnswer size={52} color="white" />,
      text: "Vereinbare ein unverbindliches Erstgespräch",
    },
  ];

  return (
    <>
      <Box w={"100%"}>
        <HeadLine
          as="h1"
          text={
            <Text>
              <b>Du</b> möchtest den nächsten <b>Schritt</b> gehen?
            </Text>
          }
        />
        <Center mt={marginTop}>
          <Wrap justify={"center"} spacing={"30px"}>
            {infos.map((info, i) => {
              return (
                <WrapItem key={i}>
                  <Card
                    w={
                      variant === "base" || variant === "sm" ? "90vw" : "300px"
                    }
                    h={"250px"}
                    bgColor={i == 2 && color.mainColor}
                    rounded="md"
                    border={`2px solid ${color.mainColor}`}
                  >
                    <CardBody>
                      <Stack h={"100%"}>
                        <Center color={color.mainColor} pt={15}>
                          {info.icon}
                        </Center>
                        <Text
                          pt={5}
                          color={i == 2 && "white"}
                          textAlign={"center"}
                          fontSize={"18px"}
                          fontWeight={"bold"}
                        >
                          {info.text}
                        </Text>
                        <Spacer />
                      </Stack>
                    </CardBody>
                  </Card>
                </WrapItem>
              );
            })}
          </Wrap>
        </Center>
        <Center pt={marginTop} w={"100%"}>
          <ActionButton />
        </Center>
      </Box>
    </>
  );
}
